import {
  CoursesWrapper,
  CoursesTitle,
  CourseList,
  CourseCard,
  CourseHeader,
  CourseCode,
  DueSoonBadge,
  CourseTitle,
  CourseMeta,
  CourseMetaItem,
  CourseDetails,
  NextClass,
  Upcoming,
  ProgressSection,
  ProgressLabel,
  ProgressBar,
  ProgressPercent,
  ViewDetailsButton
} from './CurrentCourses.styles.ts';
import { FaUser, FaClock, FaMapMarkerAlt } from 'react-icons/fa';

const courses = [
  {
    code: 'CS 301',
    title: 'Data Structures & Algorithms',
    instructor: 'Dr. Jennifer Adams',
    schedule: 'MWF 10:00-11:15 AM',
    location: 'Science Hall 204',
    nextClass: 'Today at 10:00 AM',
    upcoming: 'Midterm Project',
    upcomingDue: 'Due Oct 25, 2024',
    progress: 78,
    dueSoon: false,
  },
  {
    code: 'CS 205',
    title: 'Computer Systems & Architecture',
    instructor: 'Prof. Michael Chen',
    schedule: 'TR 2:00-3:30 PM',
    location: 'Engineering Building 301',
    nextClass: 'Tomorrow at 2:00 PM',
    upcoming: 'Assembly Language Lab',
    upcomingDue: 'Due Oct 22, 2024',
    progress: 85,
    dueSoon: false,
  },
  {
    code: 'MATH 310',
    title: 'Discrete Mathematics',
    instructor: 'Dr. Sarah Williams',
    schedule: 'MWF 1:00-2:15 PM',
    location: 'Mathematics Building 105',
    nextClass: 'Today at 1:00 PM',
    upcoming: 'Graph Theory Problem Set',
    upcomingDue: 'Due Oct 20, 2024',
    progress: 72,
    dueSoon: true,
  },
  {
    code: 'ENG 102',
    title: 'Academic Writing & Research',
    instructor: 'Prof. David Thompson',
    schedule: 'TR 11:00-12:15 PM',
    location: 'Liberal Arts 220',
    nextClass: 'Tomorrow at 11:00 AM',
    upcoming: 'Research Paper Draft',
    upcomingDue: 'Due Oct 28, 2024',
    progress: 90,
    dueSoon: false,
  },
];

const CurrentCourses = () => (
  <CoursesWrapper>
    <CoursesTitle>
      <span role="img" aria-label="courses">📖</span> Current Courses - Fall 2024
    </CoursesTitle>
    <CourseList>
      {courses.map((course) => (
        <CourseCard key={course.code} $dueSoon={course.dueSoon}>
          <CourseHeader>
            <CourseCode>{course.code}</CourseCode>
            {course.dueSoon && <DueSoonBadge>Due Soon</DueSoonBadge>}
          </CourseHeader>
          <CourseTitle>{course.title}</CourseTitle>
          <CourseMeta>
            <CourseMetaItem><FaUser /> {course.instructor}</CourseMetaItem>
            <CourseMetaItem><FaClock /> {course.schedule}</CourseMetaItem>
            <CourseMetaItem><FaMapMarkerAlt /> {course.location}</CourseMetaItem>
          </CourseMeta>
          <CourseDetails>
            <NextClass>
              <strong>Next Class:</strong> {course.nextClass}
            </NextClass>
            <Upcoming>
              <strong>Upcoming:</strong> {course.upcoming} <span style={{ color: course.dueSoon ? '#B91C1C' : '#7B2639' }}>{course.upcomingDue}</span>
            </Upcoming>
          </CourseDetails>
          <ProgressSection>
            <ProgressLabel>Progress</ProgressLabel>
            <ProgressBar>
              <div style={{ width: `${course.progress}%` }} />
            </ProgressBar>
            <ProgressPercent>{course.progress}%</ProgressPercent>
          </ProgressSection>
          <ViewDetailsButton>View Details</ViewDetailsButton>
        </CourseCard>
      ))}
    </CourseList>
  </CoursesWrapper>
);

export default CurrentCourses;
